import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useSettingsContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [settingsPage, setSettingsPage] = useState(null);
  const [showSettingsPopup, setShowSettingsPopup] = useState(false);

  const closeSettings = useCallback(() => {
    setShowSettingsPopup(false);
    setSettingsPage(null);
    navigate('/');
  }, [navigate]);

  const openSettings = useCallback(
    page => {
      const target = page && page !== 'overview' ? page : 'overview';
      setShowSettingsPopup(true);
      setSettingsPage(target);
      navigate(target === 'overview' ? '/settings' : `/settings/${target}`);
    },
    [navigate],
  );

  const handleSettingsNavigate = useCallback(
    target => {
      const next = target || 'overview';
      setSettingsPage(next);
      navigate(next === 'overview' ? '/settings' : `/settings/${next}`);
    },
    [navigate],
  );

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/settings')) {
      const target = path.split('/')[2] || 'overview';
      setShowSettingsPopup(true);
      setSettingsPage(target);
    } else {
      setShowSettingsPopup(false);
      setSettingsPage(null);
    }
  }, [location.pathname]);

  return {
    settingsPage,
    showSettingsPopup,
    openSettings,
    closeSettings,
    handleSettingsNavigate,
  };
};

export { useSettingsContent };
